import { InputVariants } from '@anm/components/form/Input';
import { LabelVariant } from '@anm/components/form/InputLabel';

type InputProps = { inputVariant: InputVariants; labelVariant: LabelVariant };

const inputProps: InputProps = {
  inputVariant: 'simple-small',
  labelVariant: 'static-above'
};

export const emailCampaignFields = [
  [
    {
      name: 'utm_source',
      label: 'Campaign source',
      placeholder: 'Wave_video',
      ...inputProps
    },
    {
      name: 'utm_medium',
      label: 'Campaign medium',
      placeholder: 'email',
      ...inputProps
    }
  ],
  [
    {
      name: 'utm_campaign',
      label: 'Campaign name',
      placeholder: 'spring_sale',
      ...inputProps
    },
    {
      name: 'utm_content',
      label: 'Campaign content',
      placeholder: 'blue_logo',
      ...inputProps
    }
  ]
];

export const callToActionFields = [
  [
    {
      name: 'utm_source',
      label: 'Campaign source',
      placeholder: 'Wave_video',
      ...inputProps
    },
    {
      name: 'utm_medium',
      label: 'Campaign medium',
      placeholder: 'landing',
      ...inputProps
    }
  ],
  [
    {
      name: 'utm_campaign',
      label: 'Campaign name',
      placeholder: 'spring_sale',
      ...inputProps
    },
    {
      name: 'utm_content',
      label: 'Campaign content',
      placeholder: 'blue_logo',
      ...inputProps
    }
  ]
];
